import type { CurrencyCode } from "@beautypie/core";
import type { LocaleType } from "../../../lib/apollo/types";

const removeZeroDecimalsRegex = /\.0+$/gim;

/**
 * @param value monetary value in subunit (cents or pence)
 * @param locale
 * @param currencyCode
 */
export function formatCurrency(
  value: number,
  locale: LocaleType,
  currencyCode: CurrencyCode,
  removeZeroDecimals = false
): string {
  if (!Number.isInteger(value)) {
    throw new Error("Expecting a value in subunits");
  }
  const res = new Intl.NumberFormat(locale, {
    style: "currency",
    currency: currencyCode
  }).format(value / 100);

  return removeZeroDecimals ? res.replace(removeZeroDecimalsRegex, "") : res;
}
